import { useI18n } from '@lib/i18n'
import styled from 'styled-components/native'
import { Button } from '../Elements/Button'

const ActionsWrapper = styled.View`
  align-items: center;
  margin: 20px 0;
  padding-top: 30px;
  border-top-width: 2px;
  border-color: ${({ theme }) => theme.colors.border};
`

export function Actions({
  onSubmit,
  isSubmitLoading,
  hasQuestions,
}: {
  onSubmit: () => void
  isSubmitLoading?: boolean
  hasQuestions: boolean
}) {
  const t = useI18n()

  return (
    <ActionsWrapper>
      <Button
        label={hasQuestions ? t('actions.submit') : t('actions.gotIt')}
        onPress={onSubmit}
        isLoading={isSubmitLoading}
      />
    </ActionsWrapper>
  )
}
